<template>
  <div>
    <div v-if="message" class="alert py-2" :class="messageOk ? 'alert-success' : 'alert-warning'">{{ message }}</div>

    <h6 class="fw-bold">Features</h6>
    <p class="text-muted small">
      Switches features on or off for every user in this environment. A feature that has never been set is off.
    </p>

    <table class="table table-sm align-middle">
      <thead>
        <tr>
          <th class="custom-col-toggle">Enabled</th>
          <th>Feature</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="f of features" :key="f.name">
          <td>
            <input v-model="f.enabled" type="checkbox" class="custom-checkbox" :disabled="busy"
              :title="`switch ${f.visualName} on or off`" @change="save(f)" />
          </td>
          <td>{{ f.visualName }}</td>
          <td class="text-muted small">{{ f.description }}</td>
        </tr>
        <tr v-if="!features.length && !busy">
          <td colspan="3" class="text-center text-muted">No features available.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { api } from '@/plugins/api'
export default {
  name: 'LocationFeatures',
  data() {
    return {
      features: [],
      busy: false,
      message: '',
      messageOk: false
    }
  },
  async mounted() {
    await this.load()
  },
  methods: {
    ...mapActions(authStore, ['loadFeatures']),
    async load() {
      this.busy = true
      try {
        const list = await api.get('feature')
        this.features = Array.isArray(list) ? list : []
      } catch (e) {
        this.setMessage('The features could not be loaded.', false)
      } finally {
        this.busy = false
      }
    },
    async save(feature) {
      this.busy = true
      try {
        const list = await api.post('feature/save', { name: feature.name, enabled: feature.enabled })
        if (Array.isArray(list)) this.features = list
        // Refresh this session's own menu as well.
        await this.loadFeatures()
        this.setMessage(`${feature.visualName} ${feature.enabled ? 'enabled' : 'disabled'}.`, true)
      } catch (e) {
        feature.enabled = !feature.enabled
        this.setMessage(`${feature.visualName} could not be saved.`, false)
      } finally {
        this.busy = false
      }
    },
    setMessage(text, ok) {
      this.message = text
      this.messageOk = ok
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-col-toggle {
  width: 90px;
}
</style>
